import { render, staticRenderFns } from "./bf-checkmarks.vue?vue&type=template&id=95c93b3a&"
import script from "./bf-checkmarks.vue?vue&type=script&lang=js&"
export * from "./bf-checkmarks.vue?vue&type=script&lang=js&"
import style0 from "./bf-checkmarks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconDotCheckmark: require('/usr/src/app/components/icons/icon-dot-checkmark.vue').default})
